!function (e) {
  "function" == typeof define && define.amd ? define(e) : e();
}(function () {
  "use strict";

  var e, t;
  e = window, t = function t(e) {
    var _c = function c() {
      return (_c = Object.assign || function (e) {
        for (var t, n = 1, i = arguments.length; n < i; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    function f(n, i) {
      var o,
          r,
          a,
          e,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: []
      };
      return e = {
        next: t(0),
        throw: t(1),
        return: t(2)
      }, "function" == typeof Symbol && (e[Symbol.iterator] = function () {
        return this;
      }), e;

      function t(t) {
        return function (e) {
          return function (t) {
            if (o) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (o = 1, r && (a = 2 & t[0] ? r.return : t[0] ? r.throw || ((a = r.return) && a.call(r), 0) : r.next) && !(a = a.call(r, t[1])).done) return a;

                switch (r = 0, a && (t = [2 & t[0], a.value]), t[0]) {
                  case 0:
                  case 1:
                    a = t;
                    break;

                  case 4:
                    return s.label++, {
                      value: t[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = t[1], t = [0];
                    continue;

                  case 7:
                    t = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(a = 0 < (a = s.trys).length && a[a.length - 1]) && (6 === t[0] || 2 === t[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === t[0] && (!a || t[1] > a[0] && t[1] < a[3])) {
                      s.label = t[1];
                      break;
                    }

                    if (6 === t[0] && s.label < a[1]) {
                      s.label = a[1], a = t;
                      break;
                    }

                    if (a && s.label < a[2]) {
                      s.label = a[2], s.ops.push(t);
                      break;
                    }

                    a[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                t = i.call(n, s);
              } catch (e) {
                t = [6, e], r = 0;
              } finally {
                o = a = 0;
              }
            }

            if (5 & t[0]) throw t[1];
            return {
              value: t[0] ? t[1] : void 0,
              done: !0
            };
          }([t, e]);
        };
      }
    }

    function t(s, l) {
      return function (e, t) {
        var n,
            i,
            o,
            r = t.name,
            a = t.action;
        return u.global += l, u.models[r] += l, u.effects[r][a] += l, _c(_c({}, e), {
          global: s(u.global),
          models: _c(_c({}, e.models), (n = {}, n[r] = s(u.models[r]), n)),
          effects: _c(_c({}, e.effects), (i = {}, i[r] = _c(_c({}, e.effects[r]), (o = {}, o[a] = s(u.effects[r][a]), o)), i))
        });
      };
    }

    var u = {
      global: 0,
      models: {},
      effects: {}
    };
    e.default = function (i) {
      void 0 === i && (i = {}), function (e) {
        if (e.name && "string" != typeof e.name) throw new Error("loading plugin config name must be a string");
        if (e.asNumber && "boolean" != typeof e.asNumber) throw new Error("loading plugin config asNumber must be a boolean");
        if (e.whitelist && !Array.isArray(e.whitelist)) throw new Error("loading plugin config whitelist must be an array of strings");
        if (e.blacklist && !Array.isArray(e.blacklist)) throw new Error("loading plugin config blacklist must be an array of strings");
        if (e.whitelist && e.blacklist) throw new Error("loading plugin config cannot have both a whitelist & a blacklist");
      }(i);
      var o = i.name || "loading",
          s = !0 === i.asNumber ? function (e) {
        return e;
      } : function (e) {
        return 0 < e;
      },
          l = {
        name: o,
        reducers: {
          hide: t(s, -1),
          show: t(s, 1)
        },
        state: _c({}, u)
      };
      return u.global = 0, l.state.global = s(u.global), {
        config: {
          models: {
            loading: l
          }
        },
        onModel: function onModel(e) {
          var n = this,
              a = e.name;

          if (a !== o) {
            u.models[a] = 0, l.state.models[a] = s(u.models[a]), l.state.effects[a] = {};
            var t = this.dispatch[a];
            Object.keys(t).forEach(function (o) {
              if (!0 === n.dispatch[a][o].isEffect) {
                u.effects[a][o] = 0, l.state.effects[a][o] = s(u.effects[a][o]);
                var e = a + "/" + o;

                if ((!i.whitelist || i.whitelist.includes(e)) && (!i.blacklist || !i.blacklist.includes(e))) {
                  var r = n.dispatch[a][o],
                      t = function t() {
                    for (var i = [], e = 0; e < arguments.length; e++) {
                      i[e] = arguments[e];
                    }

                    return function (r, a, s, l) {
                      return new (s = s || Promise)(function (e, t) {
                        function n(e) {
                          try {
                            o(l.next(e));
                          } catch (e) {
                            t(e);
                          }
                        }

                        function i(e) {
                          try {
                            o(l.throw(e));
                          } catch (e) {
                            t(e);
                          }
                        }

                        function o(t) {
                          t.done ? e(t.value) : new s(function (e) {
                            e(t.value);
                          }).then(n, i);
                        }

                        o((l = l.apply(r, a || [])).next());
                      });
                    }(n, void 0, void 0, function () {
                      var t, n;
                      return f(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return e.trys.push([0, 2,, 3]), this.dispatch.loading.show({
                              name: a,
                              action: o
                            }), [4, r.apply(void 0, i)];

                          case 1:
                            return t = e.sent(), this.dispatch.loading.hide({
                              name: a,
                              action: o
                            }), [2, t];

                          case 2:
                            throw n = e.sent(), this.dispatch.loading.hide({
                              name: a,
                              action: o
                            }), n;

                          case 3:
                            return [2];
                        }
                      });
                    });
                  };

                  t.isEffect = !0, n.dispatch[a][o] = t;
                }
              }
            });
          }
        }
      };
    }, Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self).RematchLoading = {});
});